export default "__VITE_ASSET__4ja1$jyI__"